/** Org scopes shared by the sidebar's Organization menu and the `/organization/*` route guards. */
export const ORG_ADMIN_SCOPE = "org:manage_members";
export const ORG_CONTACT_DATA_SCOPE = "enrichment:manage";
export const ORG_READ_SCOPE = "org:read";
export const ORG_CRM_READ_SCOPE = "crm:read";
